import { useId } from 'react';

import './common.css';

export function Field({ label, hint, error, children, htmlFor }) {
  return (
    <div className="field">
      {label && (
        <label className="field__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {error ? (
        <span className="field__error">{error}</span>
      ) : (
        hint && <span className="field__hint">{hint}</span>
      )}
    </div>
  );
}

export function TextInput({ label, hint, error, className = '', ...rest }) {
  const id = useId();
  return (
    <Field label={label} hint={hint} error={error} htmlFor={id}>
      <input id={id} className={`input ${className}`} {...rest} />
    </Field>
  );
}

export function TextArea({ label, hint, error, mono = false, className = '', ...rest }) {
  const id = useId();
  return (
    <Field label={label} hint={hint} error={error} htmlFor={id}>
      <textarea
        id={id}
        className={`textarea ${mono ? 'textarea--mono' : ''} ${className}`}
        spellCheck={!mono}
        {...rest}
      />
    </Field>
  );
}

export function Select({ label, hint, error, options = [], placeholder, className = '', ...rest }) {
  const id = useId();
  return (
    <Field label={label} hint={hint} error={error} htmlFor={id}>
      <select id={id} className={`select ${className}`} {...rest}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
    </Field>
  );
}

export function Switch({ checked, onChange, label, disabled = false, title }) {
  return (
    <label className={`switch ${checked ? 'switch--on' : ''}`} title={title}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="switch__track" aria-hidden="true" />
      {label && <span>{label}</span>}
    </label>
  );
}
